import { Layout, Summary ,AddSector } from '@/views/sector';

export default {
    path: '/sector',
    component: Layout,
    children: [
        { path: 'summary', component: Summary },
        { path: 'add', component: AddSector },
    ]
};
